import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import "./colorThemeCard.css";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,ChevronRight,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog} from 'lucide-react';

const ColorThemeCard =({themeText,themeSubText,fontFamily,bgColor,activeCardBorder,textIconBG,primaryColor,textIconPrimary,
  buttonColor,textIconButton,activeCard,onClickPopup})=>{

    
     const dispatch = useDispatch();
     
      
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
     
      const activeCardBorderIn =activeCard?"4px solid #90CAF9":"4px solid #fff";
       const activeCardBorderStyle={border:activeCardBorderIn,padding:"0px",margin:"0px"}
      const bgColorStyle={background:bgColor,border:activeCardBorder,paddingTop:"10px",
          fontFamily:fontFamily,color:textIconBG
      }
      const textIconBGStyle={background:textIconBG,padding:"0px",margin:"0px"}
      const primaryColorStyle={background:primaryColor,padding:"0px",margin:"0px"}
      const textIconPrimaryStyle={background:textIconPrimary,padding:"0px",margin:"0px",height:"35px"}
      const buttonColorStyle={background:buttonColor,padding:"0px",margin:"0px"}
      const textIconButtonStyle={background:textIconButton,padding:"0px",margin:"0px",height:"35px"}
     
      return (<>
        <div   onMouseEnter={()=>handleMouseEnter("","","")}
onMouseLeave={handleMouseLeave}  onClick={()=>onClickPopup()}  className="itemColorThemeCard"
 style={activeCardBorderStyle}> {activeCard?<div className="activeColorCardIcon"><Check size={20}  color={"#fff"} /></div>:""}

<div onMouseEnter={()=>handleMouseEnter("#fff","#333","Primary Color")}
onMouseLeave={handleMouseLeave}  style={primaryColorStyle}><div style={textIconPrimaryStyle} ></div> </div>
<div onMouseEnter={()=>handleMouseEnter("#fff","#333","Buttons Color")}
onMouseLeave={handleMouseLeave} style={buttonColorStyle}><div style={textIconButtonStyle} ></div>
</div>

{/* <div style={textIconBGStyle}></div> */}

<div onMouseEnter={()=>handleMouseEnter("#fff","#333","Background Color")}
onMouseLeave={handleMouseLeave} style={bgColorStyle}><div style={{fontSize:"24px",fontWeight:"bold"}}>{themeText}</div>
<div style={{fontSize:"14px"}}>{themeSubText}</div></div> 


   </div></>)
}
export default ColorThemeCard;

